module.exports = __webpack_public_path__ + "img/line-engine-md.c5ff2e73.svg";